/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { Button } from "@mui/material";
import { TimelineItem } from "./timeline-item";
import { RichText } from "@simplicitycms/simplicity-richtext";
import { useHeaderNavLinks } from "components/header/use-header-nav-links";

const TimelineComponent = (props) => {
    const { component } = props;
    const { description, link, section, subtitle, timelines, title } = component || {};
    const { text: link_text } = link || {};

    const hasLink = link && link_text;
    const hasTimelineItems = timelines && timelines.length > 0;

    const pageAnchorLinks = useHeaderNavLinks();
    const stayInformedSectionTitle = "Stay Informed";
    const stayInformedSection = pageAnchorLinks?.find(({ title }) => title === stayInformedSectionTitle);
    const stayInformedSectionId = stayInformedSection?.id;

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <div className='simplicity-timeline'>
            <div className='timeline-left'>
                {section && <h4>{section}</h4>}
                {title && <h2>{title} {subtitle && <span>{subtitle}</span>}</h2>}

                {description && <RichText richtext={description} />}

                {hasLink &&
                    <div className='timeline-link-button'>
                        <Button onClick={() => scrollToSection(stayInformedSectionId)}>
                            {link_text}
                        </Button>
                    </div>
                }

            </div>
            {hasTimelineItems &&
                <div className='timeline-right'>
                    {timelines.map((timeline, index) => {
                        return (
                            <TimelineItem item={timeline} key={`timeline-item-${index}`} />
                        );
                    })}
                </div>
            }
        </div>
    );
};

TimelineComponent.displayName = "TimelineComponent";
export { TimelineComponent };
